// Rutas del módulo Gestión institucional. Todo va en el chunk lazy
// "institucional": el bundle principal solo lleva este archivo y el menú.
const Layout = () =>
  import(/* webpackChunkName: "institucional" */ "@/components/institucional/InstitutionalLayout.vue");
const NetworkSummary = () => import(/* webpackChunkName: "institucional" */ "./NetworkSummary.vue");
const NetworkSchools = () => import(/* webpackChunkName: "institucional" */ "./NetworkSchools.vue");
const SchoolDetail = () => import(/* webpackChunkName: "institucional" */ "./SchoolDetail.vue");
const NetworkExpirations = () => import(/* webpackChunkName: "institucional" */ "./NetworkExpirations.vue");
const NetworkActivity = () => import(/* webpackChunkName: "institucional" */ "./NetworkActivity.vue");
const NetworkSubsidy = () => import(/* webpackChunkName: "institucional" */ "./NetworkSubsidy.vue");

const meta = { layout: Layout };

export default [
  { path: "/institucional", name: "institucional-resumen", meta, component: NetworkSummary },
  { path: "/institucional/colegios", name: "institucional-colegios", meta, component: NetworkSchools },
  { path: "/institucional/colegios/:schoolId", name: "institucional-colegio", meta, component: SchoolDetail },
  { path: "/institucional/vencimientos", name: "institucional-vencimientos", meta, component: NetworkExpirations },
  { path: "/institucional/actividad", name: "institucional-actividad", meta, component: NetworkActivity },
  { path: "/institucional/subvencion", name: "institucional-subvencion", meta, component: NetworkSubsidy },
];
